import { CSSProperties } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  getGoogleMapsUrl,
  getLocationCoordinates,
  MapCoordinates,
} from "utils/googleMaps.util";

type MapLocationLinkProps = {
  title?: string;
  address?: string;
  coordinates?: MapCoordinates;
  location?: {
    coordinates?: MapCoordinates;
    details?: { coordinates?: MapCoordinates };
  };
  style?: CSSProperties;
  titleStyle?: CSSProperties;
};

function MapOpenButton({ url }: { url: string }) {
  return (
    <Tooltip title="Open in Google Maps" arrow placement="top">
      <IconButton
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        aria-label="Open in Google Maps"
        sx={{
          width: 24,
          height: 24,
          ml: 0.25,
          p: 0.25,
          flexShrink: 0,
          alignSelf: "center",
          color: "#520A76",
          "&:hover": {
            bgcolor: "transparent",
            color: "#3d0858",
          },
        }}
      >
        <OpenInNewIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
}

export default function MapLocationLink({
  title,
  address,
  coordinates,
  location,
  style,
  titleStyle,
}: MapLocationLinkProps) {
  const resolvedCoordinates = coordinates ?? getLocationCoordinates(location);
  const searchAddress = [title, address].filter((part) => part?.trim()).join(", ");
  const mapsUrl = getGoogleMapsUrl(searchAddress, resolvedCoordinates);

  if (!title && !address) {
    return null;
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        maxWidth: "100%",
        ...style,
      }}
    >
      <span>
        {title ? (
          <span style={{ fontWeight: 600, ...titleStyle }}>{title}</span>
        ) : null}
        {title && address ? <br /> : null}
        {address ? <span>{address}</span> : null}
      </span>
      {mapsUrl ? <MapOpenButton url={mapsUrl} /> : null}
    </span>
  );
}
